// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { IFieldGetDropdownAttrs } from 'interfaces/back-office/master/field/field-view.interface'

const useMasterField = () => {
  // Hook
  const {
    masterField: {
      masterField_isLoading,
      masterField_dropdown,
      masterField_CLEAR_FIELD_DROPDOWN,
      masterField_fetchFieldDropdown: masterFieldFetchDropdown,
    },
  } = useStores()

  /**
   * @description Fetch field dropdown
   *
   * @param {IFieldGetDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterField_fetchFieldDropdown = useCallback((payload: IFieldGetDropdownAttrs): Promise<void> => {
    return new Promise((resolve, reject) => {
      masterFieldFetchDropdown({
        requestConfig: payload.requestConfig,
        onSuccess: resolve,
        onError: reject,
      })
    })

    // eslint-disable-next-line
  }, [])

  return {
    masterField_isLoading,
    masterField_dropdown,
    masterField_CLEAR_FIELD_DROPDOWN,
    masterField_fetchFieldDropdown,
  }
}

export { useMasterField }
